// appUrl
// ------
// Canonical public portal URL for building auth-redirect links (password reset,
// invites). Prefers the build-time VITE_PORTAL_URL so emailed links always point
// at the custom domain (e.g. portal.zephyreducation.com.au) regardless of which
// host the user happened to trigger the action from -- the same build is served
// on both the Vercel alias and the custom domain, so baking the canonical base
// at build time keeps every reset/recovery link consistent. Falls back to the
// current origin in dev / preview where the env var isn't set.

export function portalBaseUrl(): string {
  const configured = import.meta.env.VITE_PORTAL_URL;
  if (configured) return configured.replace(/\/+$/, "");
  return typeof window !== "undefined" && window.location ? window.location.origin : "";
}

// Redirect target for a password-reset / recovery email. The ?reset=1 flag is
// what the app's recovery detection keys on (reliable for the PKCE flow even
// when an existing session would otherwise swallow the recovery event).
export function passwordResetRedirect(): string {
  return `${portalBaseUrl()}/?reset=1`;
}
